$(document).on("click", ".question_product,.faq_question,.section3_icons_lp .icons_with_text_item_flex", function(e) {
    jQuery(this).hasClass("active") ? (jQuery(this).toggleClass("active"),
    jQuery(this).next().slideToggle()) : (jQuery(".question_product,.faq_question,.section3_icons_lp .icons_with_text_item_flex").removeClass("active"),
    jQuery(".question_product,.faq_question,.section3_icons_lp .icons_with_text_item_flex").next().slideUp(),
    jQuery(this).toggleClass("active"),
    jQuery(this).next().slideToggle())
}),
$(document).on("click", ".custom_button", function(e) {
    var video = jQuery(this).parents(".video_wrapper_custom").find("video");
    jQuery(this).hasClass("active") ? (jQuery(this).parents(".video_wrapper_custom").removeClass("video-active"),
    jQuery(this).removeClass("active"),
    video.trigger("pause")) : (video.trigger("play"),
    jQuery(this).parents(".video_wrapper_custom").addClass("video-active"),
    jQuery(this).addClass("active"))
}),
$(document).on("click", "a[href='#compare']", function(e) {
    e.preventDefault(),
    document.querySelector("#compare").scrollIntoView({
        behavior: "smooth"
    })
}),
$(document).on("click", "a[href='#reviews']", function(e) {
    e.preventDefault(),
    document.querySelector("#reviews").scrollIntoView({
        behavior: "smooth"
    })
}),
$(document).on("click", "a[href='#faq']", function(e) {
    e.preventDefault(),
    document.querySelector("#faq").scrollIntoView({
        behavior: "smooth"
    })
}),
$(document).on("click", "a[href='#']", function(e) {
    e.preventDefault(),
    document.querySelector(".landing_page_product").scrollIntoView({
        behavior: "smooth"
    })
}),
jQuery(document).ready(function() {
    navigator.userAgent.indexOf("Mac") > 0 ? jQuery("body").addClass("mac-os") : jQuery("body").addClass("window-os")
});
function isAtViewportMidline(el) {
    if (!el || !el.getBoundingClientRect || !$(el).is(":visible"))
        return !1;
    const rect = el.getBoundingClientRect()
      , vw = window.innerWidth || document.documentElement.clientWidth
      , midY = (window.innerHeight || document.documentElement.clientHeight) / 2;
    return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY
}
function runCounters($block) {
    $block.addClass("start_count"),
    $block.find(".count_js").each(function() {
        const $c = $(this)
          , target = +($c.data("value") || 0);
        $c.prop("Counter", 0).stop(!0).animate({
            Counter: target
        }, {
            duration: 2e3,
            easing: "swing",
            step: function(now) {
                $c.text(Math.ceil(now))
            }
        })
    })
}
function checkCountersInView() {
    $(".custom_counter .icons_with_text_flex").each(function() {
        const $block = $(this);
        $block.hasClass("start_count") || isAtViewportMidline(this) && runCounters($block)
    })
}
$(window).on("scroll load", checkCountersInView),
$(document).on("click", ".tab_item_pdp", function(e) {
    var data_tab = $(this).attr("data_tab");
    $(".tab_item_pdp").removeClass("active"),
    $(this).addClass("active"),
    $(".tab_content_pdp").hide(),
    $('.tab_content_pdp[data_tab="' + data_tab + '"]').show()
}),
$(document).on("click", ".ajax_add_cart", function(e) {
    e.preventDefault();
    var this_element = jQuery(this);
    this_element.addClass("loading_hk");
    var id = jQuery(this).attr("variant_id");
    jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            quantity: 1,
            id
        },
        dataType: "json",
        success: function(data) {
            $.get(window.location.pathname, function(res) {
                var $new = $(res).find("#cart_drawer_content");
                $("#cart_drawer_content").replaceWith($new);
                const $newCartCount = $(res).find(".cart_count_js")
                  , cartCount = parseInt($newCartCount.text().trim(), 10);
                cartCount > 0 ? $(".cart_count_js").text(cartCount).show() : $(".cart_count_js").text("").hide(),
                $("#cart-drawer").removeClass("is_empty").addClass("open"),
                $(".custom_overlay2").addClass("active"),
                this_element.removeClass("loading_hk")
            })
        }
    })
}),
$(window).scroll(function() {
    $(this).scrollTop() > 30 ? $("body").addClass("remove_transparent") : $("body").removeClass("remove_transparent")
});
function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop()
      , docViewBottom = docViewTop + $(window).height();
    docViewBottom = docViewBottom - $(window).height() / 2 + $(elem).height() + 100;
    var elemTop = $(elem).offset().top
      , elemBottom = elemTop + $(elem).height();
    return elemBottom <= docViewBottom
}
$(window).scroll(function() {
    $(".timeline_icons .icons_with_text_item").each(function() {
        isScrolledIntoView2(this) === !0 ? $(this).addClass("active") : $(this).removeClass("active")
    })
}),
$(document).on("click", ".trigger_reviews_js_show", function(e) {
    $(".review_with_text_landing_page_item.active").last().next().show(),
    $(".review_with_text_landing_page_item.active").last().next().next().show(),
    $(".review_with_text_landing_page_item.active").last().next().next().next().show(),
    $(".review_with_text_landing_page_item.active").last().next().addClass("active"),
    $(".review_with_text_landing_page_item.active").last().next().addClass("active"),
    $(".review_with_text_landing_page_item.active").last().next().addClass("active")
}),
$(document).on("click", ".trigger_reviews_js_hide", function(e) {
    $(".review_with_text_landing_page_item:nth-child(3)~.review_with_text_landing_page_item").hide().removeClass("active")
});
//# sourceMappingURL=/cdn/shop/t/43/assets/lp_pdp.js.map?v=153195892153402908871780652075
